var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css, useTheme } from "styled-components";
import { Box } from "../Box";
export const RadioMark = styled.span `
  ${({ theme: { colors: { radioColors }, borders, }, }) => css `
    display: inline-flex;
    flex: none;
    position: relative;
    border: ${borders[1]} ${radioColors.markBorder};
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    top: 1.5px; /** Align marker with label text */
    left: 0;
    border-radius: 50%;
    vertical-align: middle;
    background: ${radioColors.markBackground};

    &:hover {
      border: 1px solid ${radioColors.markHoverBorder};
    }

    &::after {
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-radius: 50%;
      opacity: 0;
      left: 50%;
      top: 50%;
      position: absolute;
    }
  `}
`;
export const HiddenRadioInput = styled.input `
  ${({ theme: { colors: { radioColors, inputColors }, shadows, }, }) => css `
    margin: 0;
    opacity: 0;
    position: absolute;

    &:checked + ${RadioMark} {
      background: ${radioColors.inputCheckedBackground};

      &::after {
        background: ${radioColors.backgroundAfter};
        width: 6px;
        height: 6px;
        opacity: 1;
        left: 4px;
        top: 4px;
      }
    }

    &:focus + ${RadioMark} {
      box-shadow: ${shadows.searchBox.contentShadow};
      border-color: ${inputColors.inputFocusBorder};
    }

    &:disabled + ${RadioMark}, &.readOnly + ${RadioMark} {
      background: ${radioColors.disabledBackground};
      border: 1px solid ${radioColors.disabledBorder};
      cursor: not-allowed;

      &::after {
        background: ${radioColors.disabledBackgroundAfter};
      }
    }
  `}
`;
const Label = (_a) => {
    var { disabled } = _a, rest = __rest(_a, ["disabled"]);
    const { colors: { radioColors }, } = useTheme();
    return (React.createElement(Box, Object.assign({ as: "label", cursor: "pointer", color: disabled ? radioColors.disabledLabel : undefined, display: "flex", position: "relative" }, rest)));
};
/**
 * Renders a hidden radio input and a custom visual marker to the left of the `children`.
 */
export const RadioButton = (_a) => {
    var { disabled, checked, name, value, onChange, onClick, children } = _a, rest = __rest(_a, ["disabled", "checked", "name", "value", "onChange", "onClick", "children"]);
    return (React.createElement(Label, Object.assign({ disabled: disabled }, rest),
        React.createElement(HiddenRadioInput, { type: "radio", "data-testid": "radio-input", disabled: disabled, checked: checked, name: name, value: value, onChange: onChange, onClick: onClick }),
        React.createElement(RadioMark, { "data-testid": "radio-mark" }),
        children));
};
/**
 * Renders the `RadioButton` component, but also adds space to the left of the `children` being rendered.
 */
export const InputRadio = (_a) => {
    var { disabled, children } = _a, props = __rest(_a, ["disabled", "children"]);
    return (React.createElement(RadioButton, Object.assign({ disabled: disabled, py: "5px", pr: "10px" }, props),
        React.createElement(Box, { ml: 2 }, children)));
};
